export default __webpack_public_path__ + "static/media/hummus.3fa23364.png";